module.exports = __webpack_public_path__ + "static/media/gif_unactive.7a3e240f.svg";